import React, { ChangeEvent, FC } from "react";

import { Select, TextField } from "@telia/teddy";
import { PhoneNumberFormatters } from "../../../../app/utils";
import TEXT from "../../../text-consts";
import "./KeepNumberPanel.less";

export interface ExistingPhoneNumberEntry {
    firstName: string;
    phoneNumber: string;
}

export interface KeepNumberPanelProps {
    choosePhoneNumber: (phoneNumber: string, isSubscriptionBroadband: boolean) => void;
    disabled: boolean;
    existingNumbersLabel?: string;
    existingPhoneNumbers?: ExistingPhoneNumberEntry[];
    isSubscriptionBroadband: boolean;
    isValidPhoneNumber: boolean;
    labelId: string;
    placeholder?: string;
    selectedPhoneNumber: string;
}

const KeepNumberPanel: FC<KeepNumberPanelProps> = ({
    choosePhoneNumber,
    labelId,
    selectedPhoneNumber,
    isSubscriptionBroadband,
    placeholder,
    disabled,
    isValidPhoneNumber,
    existingPhoneNumbers,
    existingNumbersLabel = "Dine numre på denne fakturaen",
}) => {
    const hasDropdown = existingPhoneNumbers && existingPhoneNumbers.length > 0;
    const formatter = isSubscriptionBroadband ? PhoneNumberFormatters[3].displayFn : PhoneNumberFormatters[0].displayFn;

    return (
        <div className="keep-number-panel">
            {hasDropdown && (
                <Select
                    label={existingNumbersLabel}
                    name="existing-phone-number"
                    options={existingPhoneNumbers.map(({ phoneNumber }) => phoneNumber)}
                    onValueChange={(value) => {
                        if (value) {
                            choosePhoneNumber(value, isSubscriptionBroadband);
                        }
                        return value;
                    }}
                    disabled={disabled}
                    className="keep-number-panel__select"
                >
                    <Select.Trigger className="keep-number-panel__select-trigger">
                        <Select.Value placeholder="Velg et nummer" />
                    </Select.Trigger>
                    <Select.Content>
                        <Select.Viewport>
                            {existingPhoneNumbers.map(({ phoneNumber, firstName }) => (
                                <Select.Item data-di-mask key={phoneNumber} value={phoneNumber}>
                                    {formatter(phoneNumber.replace(/\s/g, ""))}
                                    {firstName ? ` — ${firstName}` : ""}
                                </Select.Item>
                            ))}
                        </Select.Viewport>
                    </Select.Content>
                </Select>
            )}
            <TextField disabled={disabled} isValid={isValidPhoneNumber}>
                <TextField.Label>{hasDropdown ? "Eller skriv inn manuelt" : "Fyll inn mobilnummer"}</TextField.Label>
                <TextField.Input
                    aria-labelledby={labelId}
                    type="tel"
                    value={selectedPhoneNumber}
                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                        choosePhoneNumber(event.target.value, isSubscriptionBroadband)
                    }
                    placeholder={placeholder || TEXT.PERSONAL_DETAILS.PHONENUMBER.YOUR_NUMBER}
                    data-di-mask
                />
            </TextField>
        </div>
    );
};

export default KeepNumberPanel;
